export default __webpack_public_path__ + "static/media/leafRight.ee508198.png";